const apiUrl = process.env.REACT_APP_API_URL;
export const GetAllAules = async (nom : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules?nom=${nom}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
